import type { MarketListing as MarketListingType } from '@wix/ambassador-devcenter-app-market-listing-v1-market-listing/types';
import { MarketListingWithFallback as MarketListingWithFallback } from './market-listing-with-fallback';
import { MarketListing } from './market-listing';
import type { MarketListingBase } from './types';

export class MarketListings {
  constructor(private readonly marketListings: MarketListingType[]) {}

  findByAppId(appId: string, languageCode: string, perFieldFallbackEnabled: boolean = false): MarketListingBase {
    if (perFieldFallbackEnabled) {
      return this.findByAppIdWithPerFieldFallback(appId, languageCode);
    } else {
      return this.findByAppIdWithWholeFallback(appId, languageCode);
    }
  }

  findByAppIdWithPerFieldFallback(appId: string, languageCode: string): MarketListingBase {
    const primaryMarketListing = this.marketListings.find(
      (_marketListing) =>
        _marketListing.appId === appId &&
        _marketListing.languageCode === languageCode,
    );

    const fallbackMarketListing = this.marketListings.find(
      (_marketListing) =>
        _marketListing.appId === appId &&
        _marketListing.languageCode === 'en',
    );

    const marketListings: MarketListingType[] =
      (primaryMarketListing?.languageCode === 'en'
        ? [primaryMarketListing]
        : [primaryMarketListing, fallbackMarketListing]).filter(
            (listing): listing is MarketListingType => Boolean(listing),
          );

    return new MarketListingWithFallback(marketListings);
  }

  findByAppIdWithWholeFallback(appId: string, languageCode: string): MarketListingBase {
    const marketListing = this.marketListings.find(
      (_marketListing) =>
        _marketListing.appId === appId &&
        _marketListing.languageCode === languageCode,
    );
    const ml = new MarketListing(marketListing);

    if (ml.isValid) {
      return ml;
    }

    const fallbackMarketListing = this.marketListings.find(
      (_marketListing) =>
        _marketListing.appId === appId && _marketListing.languageCode === 'en',
    );
    return new MarketListing(fallbackMarketListing);
  }
}
